// KpiCard.tsx
import React, { useEffect } from 'react';
import { Box, IconButton, Skeleton } from '@mui/material';
import { IKpiCardProps, KpiDescriptions } from './types';
import { KpiCardWrapper, ContentBox } from './KpiCard.style';
import { KPINameText, KPIValueText } from './KpiCard.style';
import { AvailableIcons, Icon, Tooltip } from 'src/components-dummy';
import { kpiActions } from '../../actions';
import { useDispatch } from 'react-redux';
import { AppThunkDispatch } from 'src/app-types';
import { formatKpiWithSign, formatMetricLabel } from '../../utils/utils';
import { useAppSelector } from 'src/hooks';
import { KPITypesEnum } from '../../types';
import { renderComparisonFooter } from './utils/renderCoparisonFooter';

export interface IKpiData {
  data: { value: number; websiteValue?: number } | null;
  loading: boolean;
  error?: string;
}

const defaultKpi: IKpiData = { data: null, loading: true };

export function KpiCard({ kpiType, timeRange, product, device, shopId }: IKpiCardProps) {
  const kpiObject =
    (useAppSelector(state => state.dataInsights.kpiValuesList[kpiType]) as IKpiData) || defaultKpi;
  const { data, loading } = kpiObject;
  const value = data?.value ?? null;
  const websiteValue = data?.websiteValue ?? null;

  const diff = websiteValue > 0 ? ((value - websiteValue) / websiteValue) * 100 : 0;
  const dispatch = useDispatch<AppThunkDispatch>();

  useEffect(() => {
    dispatch(
      kpiActions.getKpi({
        kpiType,
        shopId,
        timeRange,
        product,
        device,
      })
    );
  }, [dispatch, kpiType, timeRange, product, device, shopId]);

  return (
    <KpiCardWrapper>
      <ContentBox>
        <KPINameText>{formatMetricLabel(kpiType)}</KPINameText>

        <Box display='flex' alignItems='center'>
          {loading ? (
            <Skeleton variant='text' width={100} height={32} />
          ) : (
            <KPIValueText>{formatKpiWithSign(kpiType as KPITypesEnum, value)}</KPIValueText>
          )}
          <Tooltip value={KpiDescriptions[kpiType as KPITypesEnum]}>
            <IconButton size='small' sx={{ ml: 1 }}>
              <Icon name={AvailableIcons.InformationV3} />
            </IconButton>
          </Tooltip>
        </Box>

        {renderComparisonFooter({ loading, websiteValue, diff, kpiType })}
      </ContentBox>
    </KpiCardWrapper>
  );
}
